<template>
  <base-modal modal-content-class="game_modals rg modal_glow">
    <div class="content">
      <h1>{{ getTranslations.home_modals_resume_game_title }}</h1>

      <div class="user_img_bg">
        <base-avatar-image :src="userDetails.avatar"></base-avatar-image>
      </div>

      <p class="user_name">{{ userDetails.username }}</p>

      <p>
        {{ getTranslations.home_modals_resume_game_body_pt1 }}<br>
        {{ getTranslations.home_modals_resume_game_body_pt2 }}
      </p>

      <base-button container-class="resume" @button:click="$emit('resume:game')">
        {{ getTranslations.home_modals_resume_game_resume_button }}
      </base-button>
    </div>
  </base-modal>
</template>

<script>
import {mapGetters, mapState} from 'vuex'
import BaseModal from '../../common/modal/BaseModal'
import BaseButton from '../../common/button/BaseButton'
import BaseAvatarImage from '../../common/image/BaseAvatarImage'

export default {
  name: 'ResumeGameModal',
  components: {
    BaseModal,
    BaseButton,
    BaseAvatarImage
  },
  emits: ['resume:game'],
  computed: {
    ...mapState('common', [
      'userDetails'
    ]),
    ...mapGetters('i18n', [
      'getTranslations'
    ])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/home/modals/ResumeGameModal.vue